import types from './types';
import invoiceService from 'src/services/invoice';
import InvoiceModel from 'src/model/invoice.model';
import {
  sortType,
  statusType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';
import DateRangeModel from 'src/model/dateRange.model';
import store from 'src/store';
import {
  selectedInvoicesSel,
  isInvoiceActiveSel
} from 'src/store/modules/invoices';
import remove from 'lodash.remove';

import {
  IFiltersInvoice,
  IPaginationInvoice,
  IInvoiceCreditPayment
} from 'src/services/invoice/InvoiceService';

const getInvoices = (
  filters: IFiltersInvoice = {
    dateRange: null,
    sort: null,
    status: null,
    orderStatus: null,
    invoiceNumber: null,
    nardaNumber: null,
    orderNumber: null,
    orderReference: null
  },
  pagination: IPaginationInvoice = { page: 0 },
  isHeader?: boolean
) => (dispatch: any) => {
  const checkFilters: IFiltersInvoice = {
    dateRange: filters.dateRange ? filters.dateRange : null,
    sort: filters.sort ? filters.sort : null,
    status: filters.status ? filters.status : null,
    orderStatus: filters.orderStatus ? filters.orderStatus : null,
    invoiceNumber: filters.invoiceNumber ? filters.invoiceNumber : null,
    nardaNumber: filters.nardaNumber ? filters.nardaNumber : null,
    orderNumber: filters.orderNumber ? filters.orderNumber : null,
    orderReference: filters.orderReference ? filters.orderReference : null
  };
  dispatch(seInvoicesIsPending(true));
  dispatch(setError('getInvoices'));
  dispatch(setInvoiceDateRangeFilter(checkFilters.dateRange));
  dispatch(setInvoiceSortFilter(checkFilters.sort));
  dispatch(setInvoiceStatusFilter(checkFilters.status));
  dispatch(setInvoiceOrderStatusFilter(checkFilters.orderStatus));
  dispatch(setInvoiceInvoiceFilter(checkFilters.invoiceNumber));
  dispatch(setInvoicenardFilter(checkFilters.nardaNumber));
  dispatch(setInvoiceorderNumberFilter(checkFilters.orderNumber));
  dispatch(setInvoicepoNumberFilter(checkFilters.orderReference));

  invoiceService
    .getInvoices(checkFilters, pagination, isHeader)
    .then((response: any) => {
      dispatch(setInvoiceData(response.data));
      dispatch(setInvoicePageNumber(response.pageNumber));
      dispatch(setInvoicePageSize(response.pageSize));
      dispatch(setInvoiceTotalElements(response.totalElements));
      dispatch(setInvoiceTotalPages(response.totalPages));
      dispatch(seInvoicesIsPending(false));
      dispatch(setInvoiceDebit(response.totalDebit));
      dispatch(setInvoiceCredit(response.totalCredit));
    })
    .catch(error => {
      dispatch(setError('getInvoices', { hasFailed: true, message: error }));
      dispatch(seInvoicesIsPending(false));
      // data: []
      // pageNumber: 0
      // pageSize: 20
      // totalCredit: 0
      // totalDebit: 17415.52
      // totalElements: 0
      // totalPages: 0
      dispatch(setInvoiceData([]));
      dispatch(setInvoicePageNumber(0));
      dispatch(setInvoicePageSize(20));
      dispatch(setInvoiceTotalElements(0));
      dispatch(setInvoiceTotalPages(0));
    });
};

const getOriginalInvoices = (
  filters: IFiltersInvoice = {
    dateRange: null,
    sort: null,
    status: null,
    orderStatus: null,
    invoiceNumber: null,
    nardaNumber: null,
    orderNumber: null,
    orderReference: null
  },
  pagination: IPaginationInvoice = { page: 0 }
) => (dispatch: any) => {
  const checkFilters: IFiltersInvoice = {
    dateRange: filters.dateRange ? filters.dateRange : null,
    sort: filters.sort ? filters.sort : null,
    status: filters.status ? filters.status : 'open',
    orderStatus: filters.orderStatus ? filters.orderStatus : 'RW',
    invoiceNumber: filters.invoiceNumber
      ? filters.invoiceNumber
      : 'invoiceNumber',
    nardaNumber: filters.nardaNumber ? filters.nardaNumber : 'nardaNumber',
    orderNumber: filters.orderNumber ? filters.orderNumber : 'orderNumber',
    orderReference: filters.orderReference
      ? filters.orderReference
      : 'orderReference'
  };
  dispatch(seInvoicesIsPending(true));
  invoiceService
    .originalInvoice()
    .then((response: any) => {
      dispatch(setOriginalInvoice(response.data));
      dispatch(setOriginalInvoiceDebit(response.totalDebit));
      dispatch(setOriginalInvoiceCredit(response.totalCredit));
      dispatch(setInvoicePageNumber(response.pageNumber));
      dispatch(setInvoicePageSize(response.pageSize));
      dispatch(setInvoiceTotalElements(response.totalElements));
      dispatch(setInvoiceTotalPages(response.totalPages));
      dispatch(seInvoicesIsPending(false));
    })
    .catch(error => {
      dispatch(setError('getInvoices', { hasFailed: true, message: error }));
      dispatch(seInvoicesIsPending(false));
    });
};
const getOldestInvoices = (
  pagination: IPaginationInvoice = { page: 0, size: 20 }
) => (dispatch: any) => {
  dispatch(seInvoicesIsPending(true));
  invoiceService
    .oldestInvoice(pagination)
    .then((response: any) => {
      dispatch(setOldestInvoice(response.data));
      dispatch(setOldestInvoiceDebit(response.totalDebit));
      dispatch(setOldestInvoiceCredit(response.totalCredit));
      dispatch(setInvoicePageNumber(response.pageNumber));
      dispatch(setInvoicePageSize(response.pageSize));
      dispatch(setInvoiceTotalElements(response.totalElements));
      dispatch(setInvoiceTotalPages(response.totalPages));
      dispatch(seInvoicesIsPending(false));
    })
    .catch(error => {
      dispatch(setError('getInvoices', { hasFailed: true, message: error }));
      dispatch(seInvoicesIsPending(false));
    });
};
const getselectCredit = (
  filters: IFiltersInvoice = {
    dateRange: null,
    sort: null,
    status: null,
    orderStatus: null,
    invoiceNumber: null,
    nardaNumber: null,
    orderNumber: null,
    orderReference: null
  },
  pagination: IPaginationInvoice = { page: 0 }
) => (dispatch: any) => {
  const checkFilters: IFiltersInvoice = {
    dateRange: filters.dateRange ? filters.dateRange : null,
    sort: filters.sort ? filters.sort : null,
    status: filters.status ? filters.status : 'open',
    orderStatus: filters.orderStatus ? filters.orderStatus : 'IN',
    invoiceNumber: filters.invoiceNumber ? filters.invoiceNumber : null,
    nardaNumber: filters.nardaNumber ? filters.nardaNumber : null,
    orderNumber: filters.orderNumber ? filters.orderNumber : null,
    orderReference: filters.orderReference ? filters.orderReference : null
  };
  dispatch(seInvoicesIsPending(true));
  invoiceService
    .selectCredit(checkFilters, pagination)
    .then((response: any) => {
      dispatch(setSelectcredit(response.data));
      dispatch(setCreditInvoiceCredit(response.totalCredit));
      dispatch(setCreditInvoiceDebit(response.totalCredit));
      dispatch(setInvoicePageNumber(response.pageNumber));
      dispatch(setInvoicePageSize(response.pageSize));
      dispatch(setCreditInvoiceTotalElements(response.totalElements));
      dispatch(setInvoiceTotalPages(response.totalPages));
      dispatch(seInvoicesIsPending(false));
    })
    .catch(error => {
      dispatch(setError('getInvoices', { hasFailed: true, message: error }));
      dispatch(seInvoicesIsPending(false));
    });
};

const getCreditDebitSummary = (type: any) => (dispatch: any) => {
  dispatch(seInvoicesIsPending(true));
  invoiceService
    .creditDebitSummary(type)
    .then((response: any) => {
      console.log(response);
      dispatch(setCreditInvoiceCredit(response.totalCredit));
      dispatch(setCreditInvoiceDebit(response.totalDebit));
      dispatch(seInvoicesIsPending(false));
    })
    .catch(error => {
      dispatch(setError('getInvoices', { hasFailed: true, message: error }));
      dispatch(seInvoicesIsPending(false));
    });
};

const payInvoicesByCredit = (
  invoicePayments: IInvoiceCreditPayment[],
  signature: string
) => (dispatch: any) => {
  dispatch(setError('payByCredit'));
  dispatch(setSuccess());
  invoiceService
    .payInvoicesByCredits(invoicePayments, signature)
    .then(res => {
      dispatch(getInvoices());
      dispatch(
        setSuccess({
          hasSucceed: true,
          message: 'Your account offset has been submitted.'
        })
      );
      dispatch(clearSelectedInvoices());
    })
    .catch(error => {
      if (error.response && error.response.data.status === 400) {
        if (
          error.response.data.message ===
          'Pay By Credits Request Total Must Be Zero'
        ) {
          dispatch(
            setError('payByCredit', {
              hasFailed: true,
              message: 'The application selected does not equal zero.'
            })
          );
        } else {
          dispatch(
            setError('payByCredit', {
              hasFailed: true,
              message: error.response.data.message
            })
          );
        }
      } else {
        dispatch(
          setError('payByCredit', { hasFailed: true, message: error.message })
        );
      }
    });
};
const manualApplyCredits = (
  invoicePayments: IInvoiceCreditPayment[],
  signature: string
) => (dispatch: any) => {
  dispatch(manualsetError('payByCredit'));
  dispatch(manualsetSuccess());
  invoiceService
    .manualApplyCredits(invoicePayments, signature)
    .then(res => {
      dispatch(getselectCredit());
      dispatch(
        manualsetSuccess({
          hasSucceed: true,
          message: 'Your account offset has been submitted.'
        })
      );
      dispatch(clearSelectedInvoices());
    })
    .catch(error => {
      if (error.response && error.response.data.status === 400) {
        if (
          error.response.data.message ===
          'Pay By Credits Request Total Must Be Zero'
        ) {
          dispatch(
            manualsetError('payByCredit', {
              hasFailed: true,
              message: 'The application selected does not equal zero.'
            })
          );
        } else {
          dispatch(
            manualsetError('payByCredit', {
              hasFailed: true,
              message: error.response.data.message
            })
          );
        }
      } else {
        dispatch(
          manualsetError('payByCredit', {
            hasFailed: true,
            message: error.message
          })
        );
      }
    });
};
const setInvoiceData = (data: InvoiceModel[]) => {
  return { type: types.SET_INVOICES_DATA, payload: data };
};

const setOriginalInvoice = (data: InvoiceModel[]) => {
  return { type: types.SET_ORIGINAL_INVOICES, payload: data };
};
const setOldestInvoice = (data: InvoiceModel[]) => {
  return { type: types.SET_OLDEST_INVOICES, payload: data };
};

const setInvoiceDateRangeFilter = (dateRange: DateRangeModel) => {
  return { type: types.SET_INVOICES_DATE_RANGE_FILTER, payload: dateRange };
};

const setInvoiceDebit = (totalDebit: number) => {
  return { type: types.SET_INVOICES_DEBIT, payload: totalDebit };
};

const setInvoiceCredit = (totalCredit: number) => {
  return { type: types.SET_INVOICES_CREDIT, payload: totalCredit };
};

const setOldestInvoiceDebit = (totalDebit: number) => {
  return { type: types.SET_OLDEST_INVOICES_DEBIT, payload: totalDebit };
};

const setOldestInvoiceCredit = (totalCredit: number) => {
  return { type: types.SET_OLDEST_INVOICES_CREDIT, payload: totalCredit };
};

const setOriginalInvoiceDebit = (totalDebit: number) => {
  return { type: types.SET_ORIGINAL_INVOICES_DEBIT, payload: totalDebit };
};

const setOriginalInvoiceCredit = (totalCredit: number) => {
  return { type: types.SET_ORIGINAL_INVOICES_CREDIT, payload: totalCredit };
};
const setSelectcredit = (data: InvoiceModel[]) => {
  return { type: types.SET_CREDIT_INVOICES, payload: data };
};

const setCreditInvoiceCredit = (totalCredit: InvoiceModel[]) => {
  return { type: types.SET_CREDIT_INVOICES_CREDIT, payload: totalCredit };
};
const setCreditInvoiceDebit = (totalDebit: InvoiceModel[]) => {
  return { type: types.SET_CREDIT_INVOICES_DEBIT, payload: totalDebit };
};

const setInvoiceSortFilter = (sortFilter: {
  type: sortType;
  order: 'asc' | 'desc';
}) => {
  return { type: types.SET_INVOICES_SORT_FILTER, payload: sortFilter };
};

const setInvoiceStatusFilter = (statusFilter: statusType) => {
  return { type: types.SET_INVOICES_STATUS_FILTER, payload: statusFilter };
};

const setInvoiceOrderStatusFilter = (orderFilter: orderType) => {
  return { type: types.SET_INVOICES_ORDER_STATUS_FILTER, payload: orderFilter };
};
const setInvoiceInvoiceFilter = (invoiceFilter: invoiceType) => {
  return { type: types.SET_INVOICES_INVOICE_FILTER, payload: invoiceFilter };
};
const setInvoicenardFilter = (nardFilter: nardType) => {
  return { type: types.SET_INVOICES_NARD_FILTER, payload: nardFilter };
};
const setInvoiceorderNumberFilter = (orderNumberFilter: ordernumberType) => {
  return { type: types.SET_INVOICES_ORDER_FILTER, payload: orderNumberFilter };
};
const setInvoicepoNumberFilter = (poNumberFilter: poType) => {
  return { type: types.SET_INVOICES_PO_FILTER, payload: poNumberFilter };
};

const setInvoicePageNumber = (pageNumber: number) => {
  return { type: types.SET_INVOICES_PAGE_NUMBER, payload: pageNumber };
};

const setInvoicePageSize = (pageSize: number) => {
  return { type: types.SET_INVOICES_PAGE_SIZE, payload: pageSize };
};

const setInvoiceTotalElements = (totalElements: number) => {
  return { type: types.SET_INVOICES_TOTAL_ELEMENTS, payload: totalElements };
};

const setCreditInvoiceTotalElements = (totalElements: number) => {
  return {
    type: types.SET_CREDIT_INVOICES_TOTAL_ELEMENTS,
    payload: totalElements
  };
};

const setInvoiceTotalPages = (totalPages: number) => {
  return { type: types.SET_INVOICES_TOTAL_PAGES, payload: totalPages };
};

const seInvoicesIsPending = (isPending: boolean) => {
  return { type: types.SET_INVOICES_IS_PENDING, payload: isPending };
};

const manualsetError = (
  action: string,
  error: any = {
    hasFailed: false,
    message: ''
  }
) => {
  return {
    type: types.SET_MANUAL_INVOICES_ERROR,
    payload: { caller: action, ...error }
  };
};
const manualsetSuccess = (
  success: any = { hasSucceed: false, message: '' }
) => {
  return {
    type: types.SET_MANUAL_INVOICES_SUCCESS,
    payload: success
  };
};
const setError = (
  action: string,
  error: any = {
    hasFailed: false,
    message: ''
  }
) => {
  return {
    type: types.SET_INVOICES_ERROR,
    payload: { caller: action, ...error }
  };
};

const setSuccess = (success: any = { hasSucceed: false, message: '' }) => {
  return {
    type: types.SET_INVOICES_SUCCESS,
    payload: success
  };
};

const setSelectedInvoices = (selectedInvoices: InvoiceModel[]) => {
  return { type: types.SET_SELECTED_INVOICES, payload: selectedInvoices };
};

const setSelectedCreditInvoices = (selectedCreditInvoices: InvoiceModel[]) => {
  return {
    type: types.SET_SELECTED_CREDIT_INVOICES,
    payload: selectedCreditInvoices
  };
};

const setIsInvoiceActive = (isInvoiceActive: string[]) => {
  return { type: types.SET_IS_INVOICE_ACTIVE, payload: isInvoiceActive };
};

const findInvoiceSelectedIndex = (
  invoice: InvoiceModel,
  selectedInvoices: InvoiceModel[]
) => {
  return selectedInvoices.findIndex(selInv => {
    return (
      selInv.transactionId === invoice.transactionId &&
      selInv.orderNumber === invoice.orderNumber
    );
  });
};

const invDifference = (
  invoices: InvoiceModel[],
  selectedInv: InvoiceModel[]
) => {
  const invs = [...invoices];
  selectedInv.map(selInv => {
    remove(invs, (invoice: InvoiceModel) => selInv.idx === invoice.idx);
  });
  return invs;
};

const addSelectedInvoices = (invoices: InvoiceModel | InvoiceModel[]) => (
  dispatch: any
) => {
  const storeData: any = store.getState();
  const selectedInvoices = selectedInvoicesSel(storeData);

  let newSelectedInvoices = [...selectedInvoices];
  const activeIdx = [...isInvoiceActiveSel(storeData)];
  if (!(invoices instanceof Array)) {
    const indexNewElement = findInvoiceSelectedIndex(
      invoices,
      selectedInvoices
    );
    if (indexNewElement === -1) {
      newSelectedInvoices.push(invoices);
      activeIdx.push(invoices.idx);
    } else {
      newSelectedInvoices.splice(indexNewElement, 1);
      const actIdx = activeIdx.findIndex(idx => idx === invoices.idx);
      activeIdx.splice(actIdx, 1);
    }
  } else {
    const newInvoices = invDifference(invoices, newSelectedInvoices);
    if (newInvoices.length === 0) {
      invoices.map(invoice => {
        remove(
          newSelectedInvoices,
          (selected: InvoiceModel) => selected.idx === invoice.idx
        );
        remove(activeIdx, (selected: string) => selected === invoice.idx);
      });
    } else {
      newSelectedInvoices = [...newSelectedInvoices, ...newInvoices];
      newInvoices.map((invoice: InvoiceModel) => {
        activeIdx.push(invoice.idx);
      });
    }
  }

  dispatch(setSelectedInvoices(newSelectedInvoices));
  dispatch(setIsInvoiceActive(activeIdx));
};

const removeInvoiceFromSelected = (invoice: InvoiceModel) => (
  dispatch: any
) => {
  const storeData: any = store.getState();
  const selectedInvoices = selectedInvoicesSel(storeData);
  const newSelectedInvoices = [...selectedInvoices];
  remove(newSelectedInvoices, (selected: InvoiceModel) => selected === invoice);
  dispatch(setSelectedInvoices(newSelectedInvoices));
};

const clearSelectedInvoices = () => (dispatch: any) => {
  dispatch(setSelectedInvoices([]));
  dispatch(setIsInvoiceActive([]));
};

export default {
  getInvoices,
  getOriginalInvoices,
  getOldestInvoices,
  setInvoiceData,
  setOriginalInvoice,
  setOldestInvoice,
  payInvoicesByCredit,
  setError,
  setSuccess,
  addSelectedInvoices,
  removeInvoiceFromSelected,
  clearSelectedInvoices,
  getselectCredit,
  setSelectcredit,
  getCreditDebitSummary,
  setSelectedInvoices,
  setSelectedCreditInvoices,
  setInvoicenardFilter,
  setInvoiceorderNumberFilter,
  setInvoicepoNumberFilter,
  setCreditInvoiceCredit,
  manualApplyCredits,
  setCreditInvoiceDebit,
  seInvoicesIsPending
};
